export default function SuccessPage() {
  const handleLogout = () => {
  
    localStorage.removeItem('userToken');
    window.location.href = '/login';
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-brand-bg px-4">
      <div className="w-full max-w-sm bg-white rounded-[30px] shadow-[0_0_2em_#e6e9f9] px-8 py-12 flex flex-col items-center gap-6 text-center">
        <div className="w-32 h-32 rounded-full bg-brand-card flex items-center justify-center">
          <svg className="w-14 h-14 text-brand-navy" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-brand-navy">Success</h1>
        <p className="text-brand-muted">Record Added Successfully!!</p>
        
        {/* Button Container */}
        <div className="w-full flex flex-col gap-3 mt-4">
          <button
            onClick={handleLogout}
            className="w-full py-3 px-4 bg-red-500 text-white rounded-xl font-medium hover:bg-red-600 transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}